import { Link } from "react-router-dom";
export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#F7F6F2]">
      <div className="paper-card p-10 text-center max-w-md">
        <h1 className="text-3xl mb-2">Checkout cancelled</h1>
        <p className="text-[#5C6B61] mb-6">No charge was made. You can try again anytime.</p>
        <Link to="/pricing" className="btn-primary">Back to pricing</Link>
      </div>
    </div>
  );
}
